

<div style="margin: 1em 0 3em 0">

	<div style="display: flex; flex-flow: row wrap; gap: 2em; justify-content: center; align-items: center;">

		<button
			mat-raised-button
			mwlCalendarToday
			[disabled]="isThisMonth()"
			[(viewDate)]="viewDate"
		>
			Heute
		</button>

		<h2 style="margin: 0; font-family: 'Passion One', cursive; color: var(--mainColor)">
			{{ viewDate | calendarDate : (view + 'ViewTitle') : 'de' }}
		</h2>

		<button
			mat-raised-button
			mwlCalendarPreviousView
			[view]="view"
			[(viewDate)]="viewDate"
		>
			<span class="material-icons">arrow_left</span>
		</button>

		<button
			mat-raised-button
			mwlCalendarNextView
			[view]="view"
			[(viewDate)]="viewDate"
		>
			<span class="material-icons">arrow_right</span>
		</button>

	</div>

</div>

<mwl-calendar-month-view
	[viewDate]="viewDate"
	[events]="events"
	[activeDayIsOpen]="false"
	[excludeDays]="excludeDays"
	locale="de"
	(beforeViewRender)="beforeMonthViewRender($event)"
	[cellTemplate]="customCellTemplateGrid"
	(dayClicked)="dayClicked($event.day)"
	[weekStartsOn]="1"
/>


<ng-template #customCellTemplateGrid let-day="day" let-locale="locale">

	<div class="cal-cell-top">
		<span class="cal-day-number">
			{{ day.date | calendarDate:'monthViewDayNumber':locale }}
		</span>
	</div>

	<div
		*ngFor="let event of day.events"
		class="eventBox"
		[ngStyle]="{ 'background-color': isPreviousOrNextMonth(day) ? '#CCCCCC' : event.color?.primary, 'border-color': event.color?.secondary }"
		title="{{event.title}}

von {{ event.start | date: 'dd.MM.YYYY HH:mm' }}
bis {{ event.end ? (event.end | date: 'dd.MM.YYYY HH:mm') : '' }}

{{ event.meta.description }}

{{ bAdmin ? 'Registrierte Benutzer: ' + (event.meta.subscribedUsernames && event.meta.subscribedUsernames.length ? event.meta.subscribedUsernames : 'keiner') : '' }}
"
		(click)="eventClicked( $event, event )"
	>

		<span *ngIf="smQuery.matches" style="font-size: 12px;">
			<span *ngIf="event.title.length > 3">{{event.title.substr(0,3)}}…</span>
			<span *ngIf="event.title.length <= 3">{{event.title}}</span>
		</span>
		<span *ngIf="mQuery.matches && !smQuery.matches" style="font-size: 14px;">
			<span *ngIf="event.title.length > 10">{{event.title.substr(0,10)}}…</span>
			<span *ngIf="event.title.length <= 10">{{event.title}}</span>
		</span>
    <span *ngIf="!smQuery.matches && !mQuery.matches">
    <span [ngClass]="{'event-title-subscribed': subscribedEventIds.includes(event.id), 'event-title-unsubscribed': unsubscribedEventIds.includes(event.id)}">
      {{ event.title }}
    </span>
  </span>
		<span
			*ngIf="subscribedEventIds.includes( event.id )"
			class="material-icons myStar"
		>star</span>
    <span
      *ngIf="unsubscribedEventIds.includes( event.id )"
      class="material-icons myStar"
    >close</span>

	</div>

</ng-template>
